import _extends from '../../../../node_modules/@babel/runtime/helpers/extends.js';
import { forwardRef, useMemo } from 'react';
import 'prop-types';
import merge from 'deepmerge';
import { useThemeContext } from '../../ThemeProvider/ThemeContext.js';
import btnLoading from '../../../styles/btnLoading.js';
import { invisible } from '../../../styles/layout/invisible.js';
import ButtonBase from './ButtonBase.js';
import defaultLabels from '../Button.en-US.js';
import useLocaleToDeriveDefault from '../../LocaleProvider/hooks/useLocaleToDeriveDefault.js';
import { jsx } from '@emotion/core';

const ButtonLoading = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    children,
    theme,
    loadingStyle,
    label,
    ...otherProps
  } = props;
  const derivedLabel = useLocaleToDeriveDefault(label, defaultLabels.loading);
  const themeTokens = useThemeContext();
  const loadingObject = useMemo(() => merge.all([btnLoading.btnLoading, btnLoading.keyframesSpinnerIndeterminate, loadingStyle ? btnLoading[loadingStyle] : btnLoading.btnPrimary_btnLoading, loadingStyle && loadingStyle !== 'btnPrimary_btnLoading' && themeTokens.primaryColor ? {
    '&::before': {
      borderLeftColor: themeTokens.primaryColor
    }
  } : {}]), [loadingStyle, themeTokens]);
  const completeStyleObject = merge.all([loadingObject, theme]);
  const onClick = event => {
    event.stopPropagation();
  };
  return jsx(ButtonBase, _extends({}, otherProps, {
    theme: completeStyleObject,
    ref: ref
  }, derivedLabel ? {
    'aria-label': derivedLabel
  } : {}, {
    "aria-disabled": true,
    "aria-live": "polite",
    "aria-atomic": "true",
    onClick: onClick
  }), jsx("span", {
    css: invisible
  }, derivedLabel || '&nbsp;'));
});
ButtonLoading.displayName = 'ButtonLoading';
ButtonLoading.defaultProps = {
  children: '',
  loadingStyle: undefined,
  label: undefined,
  type: 'button',
  theme: {}
};
var ButtonLoading$1 = ButtonLoading;

export { ButtonLoading$1 as default };
